export const contentTableConfig = {
  propList: [
    { prop: 'fillDate', label: '日期', minWidth: '120' },
    { prop: 'deptName', label: '部门', minWidth: '80' },
    { prop: 'empName', label: '员工', minWidth: '80' },
    { prop: 'introduceService', label: '介绍服务（次）', sortable: 'custom', minWidth: '80' },
    { prop: 'quotedPrice', label: '报价（次）', minWidth: '80', sortable: 'custom' },
    { prop: 'replyRate', label: '回复率（%）', minWidth: '80', sortable: 'custom' },
    { prop: 'hundredThousandLiveData', label: '10万以上直播数据（个）', minWidth: '100', sortable: 'custom' },
    {
      label: '操作',
      minWidth: '80',
      slotName: 'handler'
    }
  ]
}
